import { RichText } from "@/components/content/fields/richtext/richtext";

interface Props {
  body: string;
}

export function Text({ body }: Props) {
  return <RichText value={body} />;
}
